(function(){
  var pjEl=document.querySelector('script[id^="ProductJson-"]');
  if(!pjEl)return;
  var p=JSON.parse(pjEl.textContent);
  if(!p.tags||p.tags.indexOf('set')<0)return;
  var topH='',botH='';
  p.tags.forEach(function(t){
    if(t.indexOf('top-handle:')==0)topH=t.slice(11).trim();
    if(t.indexOf('bottom-handle:')==0)botH=t.slice(14).trim();
  });
  if(!topH||!botH)return;
  var st=document.createElement('style');
  st.textContent='.hb-save-badge{display:inline-block;font-family:var(--hb-font,inherit);font-size:13px;font-weight:600;letter-spacing:0.12em;text-transform:uppercase;color:#7A6A58;background:rgba(122,106,88,0.10);padding:6px 14px;border-radius:3px;margin-bottom:14px;}';
  document.head.appendChild(st);
  function inject(rrp,setP){
    var save=rrp-setP;
    if(save<=0)return;
    var fmt=function(c){return'AUD $'+(c/100).toFixed(0);};
    var badge=document.createElement('div');
    badge.id='hb-save-badge';
    badge.className='hb-save-badge';
    badge.textContent='Save '+fmt(save);
    function ins(){
      var el=document.getElementById('hb-sp-pickers');
      if(el&&!document.getElementById('hb-save-badge')){
        el.insertBefore(badge,el.firstChild);
        return true;
      }
      return false;
    }
    if(!ins()){var t=setInterval(function(){if(ins())clearInterval(t);},200);setTimeout(function(){clearInterval(t);},10000);}
  }
  Promise.all([
    fetch('/products/'+topH+'.json').then(function(r){return r.json();}),
    fetch('/products/'+botH+'.json').then(function(r){return r.json();})
  ]).then(function(r){
    var rrp=Math.round(parseFloat(r[0].product.variants[0].price)*100)+Math.round(parseFloat(r[1].product.variants[0].price)*100);
    inject(rrp,p.price);
  });
})();